import { HorizontalBar, mixins } from 'vue-chartjs'
const { reactiveProp }  = mixins
export default{
    props:['chartdata','options'],
    extends: HorizontalBar,
    watch: {
        chartdata(){
            this.renderChart(this.chartdata, this.options)
        }
    }
}